import { customElement } from 'lit/decorators/custom-element.js';
import { container } from 'tsyringe';
import { AbstractStandardTimelineView } from '../abstract-standard-timeline.view';
import type { TimelineViewConfig } from '../_shared/timeline-view.config';
import { KeywordRepository } from '../../domain/repositories/keyword.repository';
import type { Issue } from '../../domain/entities/issue.entity';

const VIEW_CONFIG: TimelineViewConfig = {
    entityType: 'Keyword',
    sort: { strategy: 'property', path: 'key', direction: 'ASC' },
    yItemPath: 'keywords[*].uid',
    includes: ['keywords', 'project', 'employees', 'creator', 'employeeToIssueAssignments']
};

/**
 * Timeline view grouping issues by keyword (label).
 * Route: /by-label
 *
 * Y-axis: Keyword — overrides populateTemplateFromYAxis to assign keywords.
 */
@customElement('o2d-labels-view')
export class LabelsView extends AbstractStandardTimelineView {
    protected readonly viewStateName = 'labels';
    protected readonly viewConfig = VIEW_CONFIG;

    /** Assigns clicked keyword to template issue. */
    protected override async populateTemplateFromYAxis(template: Issue, yAxisUid: string): Promise<void> {
        const keywordRepo = container.resolve(KeywordRepository);
        const keyword = await keywordRepo.findOneById(yAxisUid);
        if (keyword) {
            template.keywords = [keyword];
        }
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'o2d-labels-view': LabelsView;
    }
}
